import React from 'react';
import './Landing.css';

const LandingWidget = () => {
  return (
    <div className="landing-widget">
      <h1>E&M : Energie & Mehrwert</h1>
      {/* <p>
        Solar Word ist ein Solarinstallateur der es dir ermöglicht sowohl etwas
        gutes für dich wie auch für den Planeten zu tun. Entdecke auch Du wie
        Solar dir nicht nur Zukunftssicherheit zum Energieverbrauch bietet
        sondern sich heute schon für dich rechnen kann.
      </p> */}
    </div>
  );
};

export default LandingWidget;
